import script from "./EmpolyerWhiteList.vue?vue&type=script&setup=true&lang=js"
export * from "./EmpolyerWhiteList.vue?vue&type=script&setup=true&lang=js"

import "./EmpolyerWhiteList.vue?vue&type=style&index=0&id=72b7bb30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72b7bb30"]])

export default __exports__